<template>
  <div class="login-container">
    <img src="../assets/img/logo/Logo.png" alt="Logo" class="login-logo" />
    <h1 class="login-title">Preheat your oven, rise to the top!</h1>
    <p class="login-subtitle">Please login to continue</p>

    <div class="login-form">
      <input
        v-model="username"
        placeholder="Username"
        class="login-input"
      />
      <input
        v-model="password"
        type="password"
        placeholder="Password"
        class="login-input"
      />
      <button @click="handleLogin" class="login-button">Login</button>
      <p v-if="error" class="login-error">{{ error }}</p>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import { api } from '@/utils/api';

export default defineComponent({
  name: 'LoginPage',
  data() {
    return { username: '', password: '', error: '' };
  },
  methods: {
    async handleLogin() {
      this.error = "";

      try {
        const res = await fetch(api("login.php"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: this.username,
            password: this.password,
          }),
        });

        const data = await res.json();

        if (!res.ok || !data.success) {
          this.error = data.message || "Login gagal";
          return;
        }

        // ✅ SAVE LOGIN
        localStorage.setItem("loggedIn", "true");
        localStorage.setItem("user", JSON.stringify(data.user));

        // ✅ SEMUA USER MASUK DASHBOARD
        this.$router.push("/app/dashboard");

      } catch (e) {
        console.error(e);
        this.error = "Gagal menghubungi server";
      }
    }

  },
});
</script>

<style scoped>
.login-logo {
  max-width: 100px;
  margin: 0 auto 20px;
}
.login-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 40px;
  border-radius: 20px;
  background: #f8f9fc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-family: "Outfit", sans-serif;
  text-align: center;
}

.login-title {
  font-size: 26px;
  font-weight: 600;
  color: #111;
  margin-bottom: 6px;
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-input {
  padding: 12px 14px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  transition: border-color 0.3s;
  outline: none;
}

.login-input:focus {
  border-color: #3b82f6;
}

.login-button {
  background-color: #3b82f6;
  color: white;
  padding: 12px 16px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.login-button:hover {
  background-color: #2563eb;
}

.login-error {
  margin-top: 12px;
  color: #dc2626;
  font-size: 14px;
}
</style>
